import { OGP } from '@levelworks/shared-backend-api';
import { OgpApiService } from './ogp-api-service';

export class WorkersPoolsService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public getWorkersPools = async (params: {
    page: number;
    pageSize: number;
  }): Promise<OGP.GetWorkersPoolsResponseDto> => {
    return await this.ogpApiService.get<OGP.GetWorkersPoolsResponseDto>({
      path: `workers-pools`,
      params: { page: params.page, pageSize: params.pageSize },
    });
  };

  public createWorkersPool = async (body: {
    name: string;
    description?: string;
    serviceAgreementIds: string[];
  }): Promise<string> => {
    return await this.ogpApiService.create<string>({
      path: `workers-pools`,
      body: {
        name: body.name,
        description: body.description ?? null,
        serviceAgreementIds: body.serviceAgreementIds,
      },
    });
  };

  public getWorkersPoolDetail = async (params: {
    id: string;
  }): Promise<OGP.GetWorkersPoolResponseDto> => {
    return await this.ogpApiService.get<OGP.GetWorkersPoolResponseDto>({
      path: `workers-pools/${params.id}`,
    });
  };

  public getWorkersPoolFlexWorkers = async (
    workersPoolId: string,
    flexWorkerName?: string
  ): Promise<OGP.GetWorkersPoolWorkersResponseDto[]> => {
    return await this.ogpApiService.get<OGP.GetWorkersPoolWorkersResponseDto[]>({
      path: `workers-pools/${workersPoolId}/workers`,
      params: { flexWorkerName },
    });
  };

  public updateWorkersPool = async (
    workersPoolId: string,
    body: OGP.UpdateWorkersPoolRequestDto
  ): Promise<void> => {
    await this.ogpApiService.update({
      path: `workers-pools/${workersPoolId}`,
      body,
    });
  };

  public deleteWorkersPool = async (workersPoolId: string): Promise<void> => {
    await this.ogpApiService.delete({
      path: `workers-pools/${workersPoolId}`,
    });
  };

  public addWorkerToWorkersPool = async (
    workersPoolId: string,
    flexWorkerId: string
  ): Promise<void> => {
    await this.ogpApiService.update({
      path: `workers-pools/${workersPoolId}/add-worker/${flexWorkerId}`,
    });
  };

  public removeWorkerFromWorkersPool = async (
    workersPoolId: string,
    flexWorkerId: string
  ): Promise<void> => {
    await this.ogpApiService.update({
      path: `workers-pools/${workersPoolId}/remove-worker/${flexWorkerId}`,
    });
  };

  public getAvailableWorkersForWorkersPool = async (
    workersPoolId: string,
    filter: string
  ): Promise<OGP.GetAvailableWorkersForWorkersPoolResponseDto[]> => {
    return await this.ogpApiService.get<OGP.GetAvailableWorkersForWorkersPoolResponseDto[]>({
      path: `workers-pools/${workersPoolId}/available`,
      params: { filter },
    });
  };
}
